import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import Vue from "vue";

const state = {
  filterPresets: null,
  inboxFilterPresets: null,
  broadcastFilterPresets: null,
  broadcastsProjectsCount: {},
  filterPresetMessages: null,
};

const getters = {
  filterpresets_get_filterpresets: (state) => {
    return state.filterPresets;
  },
  filterpresets_get_filterpresets_inbox: (state) => {
    return state.inboxFilterPresets;
  },
  filterpresets_get_filterpresets_broadcast: (state) => {
    return state.broadcastFilterPresets;
  },
  filterpresets_get_broadcasts_projects_count: (state) => {
    return state.broadcastsProjectsCount;
  },
  filterpresets_get_filterpreset_messages: (state) => {
    return state.filterPresetMessages;
  },
};

const mutations = {
  FILTERPRESETS_SET_FILTERPRESETS(state, filterPresets) {
    state.filterPresets = filterPresets;
  },
  FILTERPRESETS_SET_FILTERPRESETS_BY_TYPE(state, data) {
    switch (data.type) {
      case "inbox":
        state.inboxFilterPresets = data.filterPresets;
        break;
      case "broadcast":
        state.broadcastFilterPresets = data.filterPresets;
        break;
    }
  },
  FILTERPRESETS_SET_BROADCASTS_PROJECT_COUNT(state, data) {
    Vue.set(state.broadcastsProjectsCount, data.index, data.count);
  },
  FILTERPRESETS_SET_FILTERPRESET_MESSAGES(state, filterPresetMessages) {
    state.filterPresetMessages = filterPresetMessages;
  },
};

const actions = {
  getFilterPresets({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "name",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        type: payload.params.type ? payload.params.type : "",
        is_mine: payload.params.is_mine ? payload.params.is_mine : "",
        is_global: payload.params.is_global ? payload.params.is_global : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFilterpresetsGet(params)
            .then((res) => {
              console.log("teamFilterpresetsGet", res.data.data);
              let sorted = [];
              res.data.data.forEach((val) => {
                if (val.is_global) sorted.push(val);
              });
              res.data.data.forEach((val) => {
                if (!val.is_global) sorted.push(val);
              });
              commit("FILTERPRESETS_SET_FILTERPRESETS", sorted);
              commit("FILTERPRESETS_SET_FILTERPRESETS_BY_TYPE", { filterPresets: sorted, type: payload.params.type });
              if (payload.params.type === "broadcast") {
                sorted.forEach((preset, index) => {
                  let p = preset.value;
                  if (p.time_relative && p.time_from && p.time_to) {
                    p.time_from = "";
                    p.time_to = "";
                  }
                  if (p.time_from && p.time_to && !p.time_relative) {
                    p.time_relative = "custom";
                  }
                  p.per_page = 10000;
                  dispatch("getProjectList", {
                    customLoading: true,
                    setListsSettings: false,
                    params: p,
                  }).then((res) => {
                    commit("FILTERPRESETS_SET_BROADCASTS_PROJECT_COUNT", {
                      index: "count_" + index,
                      count: res.data.meta.pagination.total,
                    });
                  });
                });
              }
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getFilterpreset({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (!payload.params) payload.params = {};
      payload.params = {
        contact: payload.contact,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFilterpresetsFilterPresetGet(params)
            .then((res) => {
              console.log("teamFilterpresetsFilterPresetGet", res.data.data);
              commit("FILTERPRESETS_SET_CURRENT_FILTERPRESET", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createFilterPreset({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (payload.value && payload.value.time_relative && payload.value.time_relative === "custom")
        delete payload.value.time_relative;
      dispatch("prepareRequest", {})
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFilterpresetsPost(params, payload)
            .then((res) => {
              console.log("teamFilterpresetsPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editFilterPreset({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFilterpresetsFilterPresetPut(params, payload.data)
            .then((res) => {
              console.log("teamFilterpresetsFilterPresetPut", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteFilterPreset({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFilterpresetsFilterPresetDelete(params)
            .then((res) => {
              console.log("teamFilterpresetsFilterPresetDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getFilterPresetMessages({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        filterPreset: payload.filterPreset,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "name",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFilterpresetsFilterPresetMessagesGet(params)
            .then((res) => {
              console.log("teamFilterpresetsFilterPresetMessagesGet", res.data.data);
              commit("FILTERPRESETS_SET_FILTERPRESET_MESSAGES", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  sendFilterPresetMessages({ commit, dispatch, rootState }, payload) {
    console.log("sendFilterPresetMessages");
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload)
        .then((params) => {
          console.log("sendFilterPresetMessages dispatch");
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamFilterpresetsFilterPresetMessagesPost(params, payload)
            .then((res) => {
              console.log("teamFilterpresetsFilterPresetMessagesPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
